import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1290cdb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "spinner tac"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "업로드되지 않은 사원입니다.", -1))
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "모든 사원이 업로드된 상태입니다.", -1))
const _hoisted_6 = { class: "SsTbTr" }
const _hoisted_7 = {
  class: "tal",
  style: {"display":"flex","justify-content":"left","align-items":"center"}
}
const _hoisted_8 = { class: "tac" }
const _hoisted_9 = { class: "tac" }
const _hoisted_10 = { class: "tac" }
const _hoisted_11 = { class: "tac" }
const _hoisted_12 = { class: "tac" }

import store from '@/store';
import axios from 'axios';
import { ref } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'WageBasicLoadNowEmp',
  emits: ['success'],
  setup(__props, { emit: __emit }) {

const dialog = ref(false);

// eslint-disable-next-line
const code = ref(store.state.AdminSisulCode) as any;

// eslint-disable-next-line
const emit = __emit
const loading = ref(false);
// eslint-disable-next-line
const empList = ref([] as any[]);

const selectEmp = ref<string[]>([]);
const selectOutEmp = ref<string[]>([]);
// eslint-disable-next-line
const formatYm = (value: any) => {
  if (!value) return '';
  const [year, month] = value.split('-');
  return `${year}년 ${month}월`;
}
const dialogOpen = async () => {
  dialog.value = true;
  selectEmp.value = [];
  selectOutEmp.value = [];
  await getNowEmpList();
}
const headersArr = ref([
  { title: 'No.', key: 'index', align: 'center', sortable: false },
  { title: '사원번호', key: 'empNum', align: 'center', sortable: true },
  { title: '이름', key: 'empName', align: 'center', sortable: true },
  { title: '직위', key: 'empJob', align: 'center', sortable: true },
  { title: '입사일', key: 'empInDate', align: 'center', sortable: true },
    { title: '퇴사일', key: 'empOutDate', align: 'center', sortable: true },
  
// eslint-disable-next-line
] as any[]);
const allSelectEmp = () => {
  if (selectEmp.value.length === empList.value.length) {
    selectEmp.value = [];
  } else {
    selectEmp.value = empList.value;
  }
};
const notSelectEmp = () => {
  dialog.value = false;
};

const saveGetNowEmpList = async () => {
  if (loading.value) return;
  if (selectEmp.value.length === 0) {
    alert('불러올 사원정보를 선택해주세요.')
    return;
  }
  const isConfirmed = window.confirm('사원을 업로드하시겠습니까?');
  if (isConfirmed) {
    loading.value = true;
    const insertDate = store.state.AdminYYMM;
    try {
      const response = await axios.post(`/api/saveGetNowEmpList/${insertDate}/${code.value}`, { form: selectEmp.value });
      const result = response.data;
      if (result.success === true) {
        emit('success');
        dialog.value = false;
      } else {
        alert('사원 업로드에 실패하였습니다. 관리자에게 문의해주세요.');
      }
    } catch (error) {
      alert('사원 업로드를 처리할 수 없습니다.');
      console.error(error);
    } finally {
      loading.value = false;
    }
  } else {
    return;
  }
};

const getNowEmpList = async () => {
  if (loading.value) return;
  loading.value = true;
  try {
    const response = await axios.get(`/api/getNowEmpList/${code.value}/${store.state.AdminYYMM}`);
    const responseData = response.data;
    if (responseData) {
      empList.value = responseData;
      return responseData;
    } else {
      console.error('에러가 발생했습니다.');
    }
  } catch (error) {
    console.error('errorMsg:', error);
  } finally {
    loading.value = false;
  }
};


return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_btn, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (dialogOpen())),
      class: "btnColorWhite"
    }, {
      default: _withCtx(() => [
        _createTextVNode("사원 업로드")
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: dialog.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dialog).value = $event)),
      width: "660px",
      class: "fontNotoSans400"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                (loading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1))
                  : (_openBlock(), _createBlock(_component_v_data_table, {
                      key: 1,
                      "no-data-text": "데이터가 존재하지 않습니다.",
                      "fixed-header": "",
                      density: "compact",
                      scrollable: "",
                      headers: headersArr.value,
                      items: empList.value,
                      "item-value": "name",
                      class: "SsTb fontNotoSans400",
                      style: {"height":"calc(100vh - 200px)","max-height":"600px","overflow-y":"hidden","position":"relative"},
                      "items-per-page": -1,
                      "items-per-page-options": [
                { value: -1, title: '$vuetify.dataFooter.itemsPerPageAll' }
              ]
                    }, {
                      top: _withCtx(() => [
                        _createVNode(_component_v_toolbar, { flat: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_toolbar_title, {
                              class: "fontNotoSans700",
                              style: {"max-width":"120px"}
                            }, {
                              default: _withCtx(() => [
                                ((selectEmp.value.length !== empList.value.length))
                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                      key: 0,
                                      onClick: allSelectEmp,
                                      class: "btnColorWhite",
                                      style: {"width":"100px"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("전체체크")
                                      ]),
                                      _: 1
                                    }))
                                  : ((selectEmp.value.length === empList.value.length) && empList.value.length)
                                    ? (_openBlock(), _createBlock(_component_v_btn, {
                                        key: 1,
                                        onClick: allSelectEmp,
                                        class: "btnColorWhite",
                                        style: {"width":"100px"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("전체체크해제")
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            (empList.value.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                  _createElementVNode("p", null, _toDisplayString(formatYm(_unref(store).state.AdminYYMM)) + " 계약 기간은 맞으나, 임금기초 리스트에", 1),
                                  _hoisted_3
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                  _createElementVNode("p", null, _toDisplayString(formatYm(_unref(store).state.AdminYYMM)) + " 임금기초 리스트에", 1),
                                  _hoisted_5
                                ]))
                          ]),
                          _: 1
                        })
                      ]),
                      item: _withCtx(({ item, index }) => [
                        _createElementVNode("tr", _hoisted_6, [
                          _createElementVNode("td", _hoisted_7, [
                            _createVNode(_component_v_checkbox, {
                              style: {"display":"inline-block"},
                              modelValue: selectEmp.value,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectEmp).value = $event)),
                              value: item,
                              color: "secondary",
                              "hide-details": ""
                            }, null, 8, ["modelValue", "value"]),
                            _createElementVNode("span", null, _toDisplayString(index + 1) + ".", 1)
                          ]),
                          _createElementVNode("td", _hoisted_8, _toDisplayString(item.empNum), 1),
                          _createElementVNode("td", _hoisted_9, _toDisplayString(item.empName), 1),
                          _createElementVNode("td", _hoisted_10, _toDisplayString(item.empJob), 1),
                          _createElementVNode("td", _hoisted_11, _toDisplayString(item.empInDate || ''), 1),
                          _createElementVNode("td", _hoisted_12, _toDisplayString(item.empOutDate || ''), 1)
                        ])
                      ]),
                      _: 1
                    }, 8, ["headers", "items", "items-per-page-options"])),
                _createVNode(_component_v_btn, {
                  style: {"width":"100%"},
                  class: "btnColorUpdate mb-1",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (saveGetNowEmpList()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("사원 업로드")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  style: {"width":"100%"},
                  class: "btnColorDark",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (notSelectEmp()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("취소")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})